import { createContext } from 'react';
import { AppContextType } from '../Interfaces/Interfaces';

const AppContext = createContext<AppContextType>({
    sharedData: {
        isModalActive: false,
        modalTarget: "",
        modalPayload: [],
        isLogged: false,
        username: ""
    },
    setSharedData: (): void => { }
});

export { AppContext}